var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teaser-option-container" }, [
    !_vm.mixedTeasers
      ? _c(
          "span",
          { staticClass: "icon" },
          [
            _c("icon", {
              attrs: { name: "icon-" + _vm.iconName, colorName: "white" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.mixedTeasers || _vm.spread
      ? _c("h2", [
          _c("span", { staticClass: "teaserSport" }, [
            _vm._v(_vm._s(_vm.sportName))
          ])
        ])
      : _c("h2", [
          _c("span", { staticClass: "teaserSport" }, [
            _vm._v(_vm._s(_vm.$t("BetSlip.tab.TEASER.option.label.MIXED")))
          ])
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "teaser-option" },
      [
        _c(
          "v-btn",
          {
            staticClass: "remove",
            attrs: { disabled: _vm.disabled || _vm.selectedTeaser < 2 },
            on: { click: _vm.decrease }
          },
          [_c("v-icon", [_vm._v("remove")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          !_vm.mixedTeasers
            ? _c("span", [
                !_vm.mixedTeasers
                  ? _c("span", { staticClass: "num-value" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.spread) + "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "spread-label" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("BetSlip.tab.TEASER.option.spread")))
                  ])
                ])
              ])
            : _c("span", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BetSlip.tab.TEASER.option.spread." +
                          (_vm.brandKey === "circa" && _vm.spread
                            ? "level"
                            : _vm.activeTeaserByGroup[_vm.groupId])
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.spread
                  ? _c("div", { staticClass: "spread-label" }, [
                      _vm._v("\n            " + _vm._s(_vm.spread) + " "),
                      _vm.brandKey === "circa"
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BetSlip.tab.TEASER.option.spread.points"
                                )
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "spread-label" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BetSlip.tab.TEASER.option.spread.mixed")
                          )
                        )
                      ])
                    ])
              ])
        ]),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "add",
            attrs: {
              disabled: _vm.disabled || _vm.selectedTeaser >= _vm.teaserLevelsNo
            },
            on: { click: _vm.increase }
          },
          [_c("v-icon", [_vm._v("add")])],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af38d4ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af38d4ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/teasers/teaserOption.vue
// module id = null
// module chunks = 